export default {
  placeholder: 'Suche',
  cancel: 'Abbrechen',
};
